import { Box, Container, Drawer, IconButton } from "@mui/material";
import React, {useState, useEffect } from "react";
import NavButtons from "./NavButtons";
import HeaderButtons from "./HeaderButtons";
import Filter from "../../components/widgets/Filter";
import { Close as CloseIcon } from "@mui/icons-material";

function MobileDrawer({
  drawerOpen,
  handleDrawerOpen,
  customBreakpoints,
  setOpenPostWalkInDialog,
  menuItems,
  currentUrl,
}) {
  const [isBetweenBreakpoints, setIsBetweenBreakpoints] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsBetweenBreakpoints(width >= 768 && width <= 1024); // Adjust breakpoints as needed
    };

    handleResize(); // Check on initial load
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (drawerOpen) {
   
      document.documentElement.style.overflowY = "hidden";
    } else {
      
      document.documentElement.style.overflow = "auto";
    }
  }, [drawerOpen]);
  const screen= ["/walkin","/search"]
  return (
    <>
      {(currentUrl === "/" || !screen.includes(currentUrl) ) ? (
        <Drawer
        open={drawerOpen}
        variant="temporary"
        anchor="right"
        sx={{
          "& .MuiDrawer-paper": {
            width: "50%",
            padding: "15px",
          },
        }}
      >
        {" "}
        <Container fixed>
          <Box textAlign={"right"}>
            <IconButton
              onClick={() => {
                handleDrawerOpen(false);
              }}
              color="inherit"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            gap: "10px",
          }}
        >
          <NavButtons
            isMobileFlag={
              customBreakpoints.isMobile ||
              customBreakpoints.isDeviceDown
            }
            menuItems={menuItems}
          />
          <HeaderButtons setOpenPostWalkInDialog={setOpenPostWalkInDialog} />
        </Box>
      </Drawer>
      ) : (
        <div
          style={{
            display: drawerOpen ? "flex" : "none",
            position: "absolute",

            justifyContent: "right",
            width: "100vw",
            height: "100vh",
            overflowY: "auto",
            background: "rgba(0, 0, 0, 0.5)",

            zIndex: 9,
          }}
        >
          <div
            style={{
              padding: "5vh 0",
              width: "auto",
              height: "auto",
              display: "flex",
              flexDirection: "column",
              justifyContent: "right",
              overflow: "auto",
            }}
          >
            <Box textAlign={"right"}>
              <IconButton
                onClick={() => {
                  handleDrawerOpen(false);
                }}
                color="inherit"
              >
                <CloseIcon />
              </IconButton>
            </Box>
            {(isBetweenBreakpoints) && (currentUrl === "/search") ?  (
            <Drawer
            open={drawerOpen}
            variant="temporary"
            anchor="right"
            sx={{
              "& .MuiDrawer-paper": {
                width: "50%",
                padding: "15px",
              },
            }}
          >
            {" "}
            <Container fixed>
              <Box textAlign={"right"}>
                <IconButton
                  onClick={() => {
                    handleDrawerOpen(false);
                  }}
                  color="inherit"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Container>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "start",
                gap: "10px",
              }}
            >
              <NavButtons
                isMobileFlag={
                  customBreakpoints.isMobile ||
                  customBreakpoints.isDeviceDown
                }
                menuItems={menuItems}
              />
              <HeaderButtons setOpenPostWalkInDialog={setOpenPostWalkInDialog} />
            </Box>
          </Drawer>) :(<Filter></Filter>)}
          </div>
        </div>
      )}
    </>
  );
}

export default MobileDrawer;
